import React, { useContext } from 'react';
import './Accessibility.css';
import { AccessibilityContext } from '../../contexts/AccessibilityContext';
import { useTranslation } from 'react-i18next';

const Accessibility = () => {
  const {
    contrasteActivo,
    aumentarActivo,
    disminuirActivo,
    cambiarContexto,
    disminuirTamanio,
    aumentarTamanio,
  } = useContext(AccessibilityContext);

  const { t } = useTranslation();

  return (
    <div className="content-example-barra ">
      <div className="barra-accesibilidad-govco">
        <button
          id="botoncontraste"
          className={`icon-contraste ${contrasteActivo ? 'active-barra-accesibilidad-govco' : ''}`}
          onClick={cambiarContexto}
        >
          <span id="titlecontraste">{t('accessibility_contrast')}</span>
        </button>
        <button
          id="botondisminuir"
          className={`icon-reducir ${disminuirActivo ? 'active-barra-accesibilidad-govco' : ''}`}
          onClick={disminuirTamanio}
        >
          <span id="titledisminuir" style={{ display: disminuirActivo ? 'none' : '' }}>{t('accessibility_reduce_letter')}</span>
        </button>
        <button
          id="botonaumentar"
          className={`icon-aumentar ${aumentarActivo ? 'active-barra-accesibilidad-govco' : ''}`}
          onClick={aumentarTamanio}
        >
          <span id="titleaumentar" style={{ display: aumentarActivo ? 'none' : '' }}>{t('accessibility_increase_letter')}</span>
        </button>
      </div>
    </div>
  );
};

export default Accessibility;